import React from "react";

const TrackingModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="tracking-modal-overlay">
            <div className="tracking-modal">
                <img src="/imagens/Cadeado.webp" alt="Dashboard" className="tracking-modal-image" />
                <h2>Em breve, para clientes premium!</h2>
                <p>Descubra qual QR Code recebe mais escaneamentos e de onde vem seu público.</p>
                <button className="btn" onClick={onClose}>Fechar</button>
            </div>
        </div>
    );
};

export default TrackingModal;